export class Point3d {
  id: number;
  x: number;
  y: number;
  z: number;

  constructor({ id = null, x = null, y = null, z = null } = {}) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.z = z;
  }
}
